<!-- Bouton flottant repositionné -->
<div class="chatbot-toggle" [class.open]="isChatOpen" (click)="toggleChat()">
  <div class="toggle-icon">
    <img *ngIf="!isChatOpen" src="assets/images/file.png" alt="Brokins" class="brokins-logo-icon">
    <i class="pi pi-times" *ngIf="isChatOpen"></i>
  </div>
  <div class="status-indicator"></div>
</div>

<!-- Widget de chat -->
<div class="chatbot-widget" [class.open]="isChatOpen">
  <!-- Header avec nouvel icône -->
  <div class="chatbot-header">
    <div class="assistant-info">
      <div class="assistant-avatar">
        <img src="assets/images/file.png" alt="Brokins" class="brokins-logo-avatar">
      </div>
      <div class="assistant-details">
        <div class="assistant-title">
          <h3>Assistant Brokins</h3>
          <span class="status">En ligne • Répond généralement en quelques secondes</span>
        </div>
      </div>
    </div>
    <div class="header-actions">
      <p-button 
        icon="pi pi-refresh" 
        severity="secondary" 
        size="small"
        [text]="true"
        (onClick)="clearChat()"
        pTooltip="Nouvelle conversation"
        tooltipPosition="left">
      </p-button>
      <p-button 
        icon="pi pi-window-minimize" 
        severity="secondary" 
        size="small"
        [text]="true"
        (onClick)="toggleChat()"
        pTooltip="Fermer"
        tooltipPosition="left">
      </p-button>
    </div>
  </div>
  
  <!-- Sélecteur de domaine -->
  <div class="domain-selector">
    <p-dropdown 
      [(ngModel)]="selectedDomain"
      [options]="domainOptions"
      optionLabel="label"
      optionValue="value"
      (onChange)="onDomainChange()"
      placeholder="Choisir un domaine"
      [style]="{'width': '100%'}"
      styleClass="domain-dropdown">
      <ng-template pTemplate="selectedItem">
        <div class="domain-option">
          <i [class]="selectedDomainIcon"></i>
          <span>{{ selectedDomainLabel }}</span>
        </div>
      </ng-template>
      <ng-template let-option pTemplate="item">
        <div class="domain-option">
          <i [class]="option.icon"></i>
          <span>{{ option.label }}</span>
        </div>
      </ng-template>
    </p-dropdown>
  </div>


  <!-- Corps du chat -->
  <div class="chatbot-body">
    <!-- Suggestions rapides -->
    <div class="quick-suggestions" *ngIf="messages.length <= 1">
      <h4>Questions fréquentes</h4>
      <p class="suggestions-description">
        Sélectionnez une question pour démarrer rapidement la conversation ou posez la vôtre juste en dessous.
      </p>
      <div class="suggestion-chips">
        <button 
          *ngFor="let suggestion of quickSuggestions" 
          class="suggestion-chip"
          (click)="sendSuggestion(suggestion)">
          {{ suggestion }}
        </button>
      </div>
    </div>

    <div #messagesContainer class="messages-container">
      <div 
        *ngFor="let message of messages; let i = index" 
        class="message-wrapper" 
        [class.user-message]="message.isUser"
        [class.bot-message]="!message.isUser">
        
        <!-- Avatar pour les messages du bot -->
        <div class="message-avatar" *ngIf="!message.isUser">
          <img src="assets/images/file.png" alt="Brokins" class="brokins-logo-avatar">
        </div>

        <div class="message-content">
          <div class="message-bubble">
            <div class="message-text" [innerHTML]="formatMessage(message.content)"></div>
            <div class="message-actions" *ngIf="!message.isUser">
              <button class="action-btn" pTooltip="Copier" (click)="copyMessage(message.content)">
                <i class="pi pi-copy"></i>
              </button>
              <button class="action-btn" pTooltip="Utile">
                <i class="pi pi-thumbs-up"></i>
              </button>
            </div>
          </div>
          <span class="message-time">
            {{ message.timestamp | date:'HH:mm' }}
          </span>
        </div>

        <!-- Avatar pour les messages utilisateur -->
        <div class="message-avatar user-avatar" *ngIf="message.isUser">
          <i class="pi pi-user"></i>
        </div>
      </div>

      <!-- Indicateur de frappe -->
      <div *ngIf="isLoading" class="message-wrapper bot-message">
        <div class="message-avatar">
          <img src="assets/images/file.png" alt="Brokins" class="brokins-logo-avatar">
        </div>
        <div class="message-content">
          <div class="message-bubble typing-indicator">
            <div class="typing-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <span class="typing-text">Assistant en train d'écrire...</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer avec bouton d'envoi corrigé -->
  <div class="chatbot-footer">
    <div class="input-container">
      <div class="input-wrapper">
        <input 
          type="text" 
          pInputText
          [(ngModel)]="currentMessage"
          (keypress)="onKeyPress($event)"
          placeholder="Tapez votre message..."
          [disabled]="isLoading"
          class="message-input">
      </div>
      
      <button 
        class="send-button"
        [disabled]="!currentMessage.trim() || isLoading"
        (click)="sendMessage()">
        <i class="pi pi-send" *ngIf="!isLoading"></i>
        <i class="pi pi-spin pi-spinner" *ngIf="isLoading"></i>
      </button>
    </div>
    
    <div class="footer-info">
      <small>Propulsé par Brokins AI • <a href="#" class="link">Politique de confidentialité</a></small>
    </div>
  </div>
</div>
